import React from "react";
import PEPRelatedTable from "./PEPRelatedTable/PEPRelatedTable";

export default function PEPRelatedCard(props) {
    const { pep_related_data } = props
    const hasSource = Object.keys(pep_related_data?.source || {}).length > 0;
    if (!hasSource) return null;
    return (
        <div style={{width: "100%", border: '1px solid #dedede', borderRadius: '8px', padding: '16px'}}>
            <p style={{fontSize: "14px", fontWeight: "bold", margin: "0 0 16px 0", padding: 0, color: '#0b1f82'}}>
                PEP Relacionado - Match encontrado
            </p>
            <PEPRelatedTable pep_related_data={pep_related_data.source} />
        </div>
    )
}
